import { Button, Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiImagingConfigSlideout extends Layout {
    buttonCustomize: Button;
    checkboxUseSequence: Checkbox;
    sourceEdiImagingConfig: DataSource;
    textboxAltImgComm: Textbox;
    textboxCustomFilename: Textbox;
    textboxImageDescription: Textbox;
    textboxImageType: Textbox;
    textboxRequired: Textbox;
}
